exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-show-history{\r\n    background-color: #DCDADB;\r\n    margin-top: 28px;\r\n}\r\n\r\ni.disabled { \r\n    opacity: 0.5 !important; \r\n    cursor: not-allowed; \r\n    pointer-events: none;\r\n}\r\n\r\n.btn-default-height{\r\n    height: 38px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/IterationEventComponent/interactionEvent.component.css
// module id = ../../../../../src/app/private/dynamicFlow/IterationEventComponent/interactionEvent.component.css
// module chunks = main